<template>
  <div></div>
</template>

<script>
export default {
  name: "PrePage"
}
</script>

<style scoped>

</style>
